import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_switch_5e92b7ed__ from "@radix-ui/react-switch";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const rootStyle = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('peer inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input', {
    variants: {
        size: {
            small: 'h-[20px] w-[36px]',
            medium: 'h-[24px] w-[44px]'
        }
    }
});
const thumbStyle = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0', {
    variants: {
        size: {
            small: 'size-4 data-[state=checked]:translate-x-4',
            medium: 'size-5 data-[state=checked]:translate-x-5'
        }
    }
});
const Switch = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, size = 'medium', ...properties }, reference)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_switch_5e92b7ed__.Root, {
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(rootStyle({
            size
        }), className),
        ...properties,
        ref: reference,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_switch_5e92b7ed__.Thumb, {
            className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(thumbStyle({
                size
            }))
        })
    }));
Switch.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_switch_5e92b7ed__.Root.displayName;
export { Switch };

//# sourceMappingURL=index.js.map